const OSMIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.75 1.2078C12.803 0.910354 11.7952 0.75 10.75 0.75C5.22715 0.75 0.75 5.22715 0.75 10.75C0.75 16.2728 5.22715 20.75 10.75 20.75C16.2728 20.75 20.75 16.2728 20.75 10.75C20.75 9.03467 20.3181 7.42022 19.5571 6.00945M15.75 4.5H15.755M9.25005 20.6383L9.25016 18.4349C9.25017 18.3156 9.29286 18.2002 9.37053 18.1096L11.8563 15.2094C12.0606 14.9711 11.9973 14.6056 11.7248 14.4499L8.86853 12.8177C8.79093 12.7734 8.72663 12.7091 8.68234 12.6314L6.82046 9.36863C6.72356 9.19882 6.53657 9.10107 6.34183 9.11841L0.814183 9.61074M19.75 4.75C19.75 6.95914 17.75 8.75 15.75 10.75C13.75 8.75 11.75 6.95914 11.75 4.75C11.75 2.54086 13.5409 0.75 15.75 0.75C17.9591 0.75 19.75 2.54086 19.75 4.75ZM16 4.5C16 4.63807 15.8881 4.75 15.75 4.75C15.6119 4.75 15.5 4.63807 15.5 4.5C15.5 4.36193 15.6119 4.25 15.75 4.25C15.8881 4.25 16 4.36193 16 4.5Z"
        stroke="white"
        strokeWidth="1.5" strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default OSMIcon
